export const rules = {
  isRequired(field) {
    return [(v) => !!(v) || `${field} is required`];
  },
  validCreditCard() {
    const cardRegex = / ^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
    return [(v) => cardRegex.test(v) || 'Valid card number required'];
  },
  validCVC() {
    const cvcRegex = /^[0-9]{3,4}$/;
    return [(v) => cvcRegex.test(v) || 'Valid CVC / CVV required'];
  },
  // validDate(field) {
  //   const dateRegEx = /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/;
  //   const [year, month, day] = field.split('-');
  //   return [(v) => dateRegEx.test(`${month}/${day}/${year}`)
  // || 'Invalid date - must be formatted MM/DD/YYYY'];
  // },
  daysFuture(days) {
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + days);
    return [(v) => (new Date(v)) >= futureDate
      || `Date must be at least ${days} days in the future`];
  },
  validEmail() {
    return [(v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address'];
  },
  validPhoneNumber() {
    return [(v) => /^[2-9]\d{2}-\d{3}-\d{4}(.*?)$/.test(v) || 'Required format: XXX-XXX-XXXX + Opt. Extension'];
  },
  validZipCode() {
    return [(v) => /^\d{5}$/.test(v) || 'A valid zip code required'];
  },
  noWhiteSpace() {
    return [(v) => v.indexOf(' ') < 0 || 'Cannot contain spaces'];
  },
  maxLength(max) {
    return [(v) => (!v || `${v}`.length <= max) || `Must be ${max} characters or fewer`];
  },
  minLength(min) {
    return [(v) => (!v || `${v}`.length >= min) || `Must be at least ${min} characters`];
  },
  maxValue(max) {
    return [(v) => (!v || v <= max) || `Must be ${max} or less`];
  },
  maxSelections(max) {
    return [(v) => v.length <= max || `Must select fewer than ${max}`];
  },
  minSelections(min) {
    return [(v) => v.length >= min || `Must select at least ${min}`];
  },
  validPassword() {
    return [
      ...this.isRequired('Password'),
      ...this.minLength(10),
      (v) => /[A-Z]/.test(v) || 'Must have 1 capital',
      (v) => /[a-z]/.test(v) || 'Must have 1 lowercase',
      (v) => /[0-9]/.test(v) || 'Must have 1 number',
      (v) => /[^A-Za-z0-9]/.test(v) || 'Must have 1 special character',
    ];
  },
  validUsername() {
    return [
      (v) => /^[A-Za-z0-9]+$/.test(v) || 'Alphanumeric characters only.',
    ];
  },
  minDollarAmount(min) {
    return [(v) => (!v || v >= min) || `Must be at least $${min}`];
  },
  minPercentage(min) {
    return [(v) => (!v || v >= min) || `Must be at least ${min}%`];
  },
  maxPercentage(max) {
    return [(v) => (!v || v <= max) || `Must not exceed ${max}%`];
  },
  maxPrecision(max) {
    return [(v) => {
      if (!v) return true;

      const decimalPlaces = v.split('.')[1];
      if (!decimalPlaces) return true;

      return decimalPlaces.length <= max || `Precision must not exceed ${max} decimal places`;
    }];
  },
};

export default { rules };
